import { useToastStore } from "../../stores/toastStore";

const variantStyles = {
  success: "bg-green-600 text-white",
  error: "bg-red-600 text-white",
  info: "bg-primary-600 text-white",
};

function CloseIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      className="w-4 h-4"
      aria-hidden="true"
    >
      <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
    </svg>
  );
}

export function ToastContainer() {
  const { toasts, removeToast } = useToastStore();

  // aria-live コンテナは常に DOM に存在させる。
  // toasts が空のとき return null すると、スクリーンリーダーが
  // aria-live 領域の追加を検知できず、後から表示されるトーストを読み上げない場合がある。
  return (
    <div
      className="fixed bottom-4 right-4 z-50 flex flex-col gap-2"
      aria-live="polite"
      aria-relevant="additions"
      aria-atomic="true"
    >
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`flex items-center gap-3 rounded-lg px-4 py-3 shadow-lg ${variantStyles[toast.variant]} animate-slide-in`}
          role={toast.variant === "error" ? "alert" : "status"}
        >
          <span className="text-sm font-medium">{toast.message}</span>
          <button
            type="button"
            onClick={() => removeToast(toast.id)}
            className="shrink-0 rounded p-0.5 opacity-80 hover:opacity-100 transition-opacity focus:outline-none focus:ring-2 focus:ring-white"
            aria-label="閉じる"
          >
            <CloseIcon />
          </button>
        </div>
      ))}
    </div>
  );
}
